import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";

import DstButton from "../../../../../components/DstButton/DstButton";
import Popup from "../../../../../components/Popup/Popup";
import translate from "../../../../../services/Translate";
import { updateProjectUserScore } from "../../../Project.function";

const UpdateScoreModal = ({ show, onClose, projectId, users, language, onSuccess }: any) => {
  const [score, setScore] = useState<number>(0);
  const [scoreBase, setScoreBase] = useState<number>(20);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (users?.length === 1) {
      setScore(users[0].score ?? 0);
      setScoreBase(users[0].score_base ?? 20);
    } else {
      setScore(0);
      setScoreBase(20);
    }
  }, [users]);

  if (!users || users.length === 0) return null;

  const _handleSubmit = () => {
    updateProjectUserScore(
      projectId,
      users.map((user: any) => user.id),
      score,
      scoreBase,
      language,
      setIsSubmitting,
      () => {
        onSuccess();
        onClose();
      }
    );
  };

  return (
    <Popup
      show={show}
      onClose={onClose}
      modalTitle={translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.UPDATE_SCORE.MODAL_TITLE")}
      footerContent={
        <React.Fragment>
          <DstButton variant="secondary" value={translate(language, "GLOBAL.CANCEL")} clickFunction={onClose} />
          <DstButton
            value={translate(language, "GLOBAL.SAVE")}
            loading={isSubmitting}
            disabled={score < 0 || scoreBase <= 0 || score > scoreBase}
            clickFunction={_handleSubmit}
          />
        </React.Fragment>
      }
    >
      <p className="fw-bold">{users.map((user: any) => user.name).join(", ")}</p>
      {users.some((user: any) => user.score != null) && (
        <p className="text-warning small">
          {translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.UPDATE_SCORE.SCORED_NOTE")}
        </p>
      )}
      <Row></Row>
      <Row>
        <Col>
          <Form.Group>
            <Form.Label>{translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.UPDATE_SCORE.FIELDS.SCORE")}</Form.Label>
            <Form.Control
              type="number"
              min={0}
              max={scoreBase}
              value={score}
              onChange={(event) => setScore(Number(event.target.value))}
            />
          </Form.Group>
        </Col>

        <Col>
          <Form.Group>
            <Form.Label>
              {translate(language, "PAGES.PROJECT.MAIN_INFOS_TAB.UPDATE_SCORE.FIELDS.SCORE_BASE")}
            </Form.Label>

            <Form.Control
              type="number"
              min={1}
              value={scoreBase}
              placeholder="20"
              onChange={(event) => setScoreBase(Number(event.target.value))}
            />
          </Form.Group>
        </Col>
      </Row>
    </Popup>
  );
};

export default UpdateScoreModal;
